<div class="mb-3">
  <label *ngIf="label" [ngClass]="{'required': required}" [for]="identifier">{{ label }}</label>
  <input [id]="identifier" type="text" class="form-control"
         name="nome" [(ngModel)]="value" (ngModelChange)="changeControlState()"
         [mask]="mask" (blur)="onBlur()" [disabled]="disabled" [required]="required"
         [ngClass]="{ 'is-invalid': form && (form.submitted || form.controls[name]?.touched || form.controls[name]?.dirty) && form.controls[name]?.errors}" />
  <validation-errors [form]="form" [controlName]="name"></validation-errors>
</div>
